var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const BagWithGift = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M17.75 9.00514C17.0878 6.3793 15.5908 6 10.7261 6C2.82037 6 3.80845 7.0017 2.82041 17.0188C2.551 19.7502 2.77132 20.8266 8.74964 21L10.5 21M7.75 8.5V5C7.75 3.343 9.093 2 10.75 2C12.407 2 13.75 3.343 13.75 5V8.5M17 15C20.5 15 21.5 15.5 21.5 18C21.5 20.5 20 21 17 21M17 15C13.5 15 12.5 15.5 12.5 18C12.5 20.5 14 21 17 21M17 15V21M17 15V13.5M17 15C14.5 15 14 13.5 14 12.5C14 11 17 10.5 17 13.5M17 15C19.5 15 20 13.5 20 12.5C20 11 17 10.5 17 13.5", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
